/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 12/11/2024
 */
import React, { useState, useEffect } from "react"
import api from "../../../../base/services/ResApi"
import AuthApi from "../../../../base/services/AuthApi"
import { Groups2 } from "@mui/icons-material"
import "../../../../styleSheets/base/styles.scss"
import "../styles/grp.styles.scss"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Alert,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  AlertTitle,
  Collapse,
  Box,
  Tooltip,
  Switch,
} from "@mui/material"
import LoadingButton from "@mui/lab/LoadingButton"
import SaveIcon from "@mui/icons-material/Save"
import OrgsDropdown from "../../../components/orgsDropdown/OrgsDropdown"
import DateTimeSelector from "../../../components/DateTimePicker/DateTimeSelector"
import IconUpload from "../../../components/iconUpload/IconUpload"
import InfoIcon from "@mui/icons-material/Info"
import CloseIcon from "@mui/icons-material/Close"
import dayjs from "dayjs"
import base64url from "base64url"
import { JSEncrypt } from "jsencrypt"
import { Password, Done } from "@mui/icons-material"
import StorageService from "../../../../base/services/StorageService"

const CreateNewGroupsModal = ({ open, onClose, setUpdateData, orgCode }) => {
  const encrypt = new JSEncrypt()
  const publicKey = `
    -----BEGIN PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsy+1EQqpdOCQM4OaAflU9rQZGzo8TexVbkez7q67egtwZT5BCG5bClBk95paacF3HgMwh4se6ZhttdkiJfr/gGagOqP2FTZKqEaz7d24FSpYyKUVdgZ7eDNgiBbkWVZi83dGqlMGM2wmES3Q614P3JN+BiZ5srvc4q0BXnw8y40MB10KY0dONVuKrywKEKoHCfjIvKJNH3FyYaCwslQC4m94ErDr5OGbO3qPLiJzw7fRoU3WN05OZvGuYkgS0yN2KUKOp/vAyG6h1Mf+bayILTAGJRxyYdLGvL8Y/90NIFNvXtO4IHfY8HO/bymOic/gPE7XU1lHTK1EvrF55a/E3wIDAQAB
    -----END PUBLIC KEY-----`
  // Assign encryptor to utilize the public key.
  encrypt.setPublicKey(publicKey)

  const username = StorageService.getUsername()

  const [data, setData] = useState({
    orgCode: orgCode,
    icon: "Groups2",
  })

  const [grpIcon, setGrpIcon] = useState(<Groups2 />)

  const [isBtnLoading, setIsBtnLoading] = useState(false)

  const [isSuccess, setIsSuccess] = useState(false)
  const [successMessage, setSuccessMessage] = useState([])
  const [iserror, setIserror] = useState(false)
  const [errorMessages, setErrorMessages] = useState([])

  //Sset schedule date
  const [scheduleDate, setScheduleDate] = useState(dayjs())
  const [deployStgy, setDeployStgy] = useState()
  const [setlmntSetting, setSetlmntSetting] = useState()

  const [isClearAppData, setIsClearAppData] = useState(false)
  const [confirmPw, setConfirmPw] = useState()
  const [isConfirmBtnDisabled, setisConfirmBtnDisabled] = useState(false)
  const [isSubmit, setIsSubmit] = useState(false)
  const [isConfirmedError, setIsConfirmedError] = useState(false)
  const [confirmedErrorMessages, setConfirmedErrorMessages] = useState()

  const [infoAlert1Open, setinfoAlert1Open] = useState(false)
  const [infoAlert2Open, setinfoAlert2Open] = useState(false)

  useEffect(() => {
    setDeployStgy("REGULAR_UPDATE")
    setSetlmntSetting("SKIP_SETTLEMENT")
  }, [])

  //clear all alerts after a timeout
  useEffect(() => {
    if (iserror === true) {
      let timerId = setTimeout(() => {
        setIserror(false)
        setErrorMessages([])
        timerId = null
      }, 5000)
      return () => clearTimeout(timerId)
    }
  }, [iserror])

  const handleChange = (e) => {
    const value = e.target.value
    setData({
      ...data,
      [e.target.name]: value,
    })
  }

  const handleScheDateChange = (newValue) => {
    setScheduleDate(newValue)
  }
  const handleDplyStgyChange = (e) => {
    setDeployStgy(e.target.value)
  }
  const handleSetlmntSetting = (e) => {
    setSetlmntSetting(e.target.value)
  }

  const handleClearAppDataChange = (e) => {
    const value = e.target.checked
    setIsClearAppData(value)
    
  }
  const handleConfirmPwChange = (e) => {
    setConfirmPw(e.target.value)
    setIsConfirmedError(false)
    setConfirmedErrorMessages()
  }

  const handleConfirmPw = () => {
    const encryptedInputPassword = encrypt.encrypt(confirmPw ? confirmPw : "")

    //Converting the encrypted password to url friendly base64URL encoded
    const urlEncodedInputPassword = base64url.toBase64(encryptedInputPassword)
    setIsSubmit(true)
    let postConfig = {
      headers: {
        "Content-Type": "application/json",
        password: urlEncodedInputPassword,
      },
    }

    AuthApi.get("/users/confirm/" + username, postConfig)
      .then((res) => {
        if (res.data === false) {
          setIsConfirmedError(true)
          setConfirmedErrorMessages("Password Incorrect")
          setIsSubmit(false)
        }
        if (res.data === true) {
          setIsConfirmedError(false)
          setConfirmedErrorMessages()
          setisConfirmBtnDisabled(true)
          setIsSubmit(false)
        }
      })
      .catch((error) => {
        setConfirmedErrorMessages(error.response.data.description)
        setIsConfirmedError(true)
        setIsSubmit(false)
      })
  }

  const handleOnClose = () => {
    setErrorMessages()
    setIserror(false)
    setSuccessMessage()
    setIsSuccess(false)
    setData({ grpName: "", description: "" })
    setisConfirmBtnDisabled(false)
    onClose()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setIsBtnLoading(true)

    const payload = {
      orgCode: data.orgCode ? data.orgCode : orgCode,
      icon: data.icon,
      grpName: data.grpName,
      description: data.description,
      deployStgy: deployStgy,
      stlmntSetting: setlmntSetting,
      schedUpdateTime: deployStgy === "SCHEDULE_UPDATE" ? scheduleDate : null,
      clearApp: isConfirmBtnDisabled? isClearAppData:false,
    }
    api
      .post("/groups", payload)
      .then((res) => {
        setErrorMessages([])
        setIserror(false)
        setIsSuccess(true)
        setSuccessMessage([res.data?.description])
        setUpdateData(true)
        setTimeout(() => {
          setIsBtnLoading(false)
          setIsSuccess(false)
          setSuccessMessage([""])
          handleOnClose()
        }, 3000)
      })
      .catch((error) => {
        setIsBtnLoading(false)
        setIsSuccess(false)

        setIserror(true)
        setErrorMessages([
          error.response.data.description
            ? error.response.data.description
            : "Group Creation Failed",
        ])
      })
  }

  return (
    <Dialog
      fullWidth={true}
      maxWidth="true"
      open={open}
      PaperProps={{
        style: { borderRadius: "10px", width: "912px", margin: 0 },
      }}
    >
      <DialogTitle className="grpFormTitle">
        Create Group
        <IconButton aria-label="cancel" onClick={handleOnClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers className="grpFormContent">
          <div className="alertDiv">
            <div>
              {isSuccess && (
                <Alert severity="success">
                  {successMessage?.map((msg, i) => {
                    return <div key={msg}>{msg}</div>
                  })}
                </Alert>
              )}
            </div>
            {iserror && (
              <Alert severity="error">
                {errorMessages.map((msg, i) => {
                  return <div key={msg}>{msg}</div>
                })}
              </Alert>
            )}
          </div>
          <div>
            <IconUpload
              tooltip={"Select Group Icon"}
              grpIcon={grpIcon}
              setgrpIcon={setGrpIcon}
              onChange={handleChange}
            />
          </div>
          <Stack spacing={2} direction="row" sx={{ marginBottom: 2 }}>
            <TextField
              name="grpName"
              value={data?.grpName}
              type="text"
              variant="outlined"
              color="secondary"
              label="Group Name"
              required
              fullWidth
              sx={{ mb: 3 }}
              onChange={handleChange}
            />
            <OrgsDropdown
              orgCode={orgCode ? orgCode : ""}
              onChange={handleChange}
              isRequired={true}
            />
          </Stack>
          <br />
          <FormControl component="fieldset">
            <FormLabel
              color="error"
              sx={{ color: "#ca6666", fontWeight: "bold" }}
            >
              Clear App Data{" "}
              <Tooltip
                title="Clear all terminal app data. Password confirmation required to proceed!"
                placement="top"
                arrow
                leaveDelay={200}
              >
                <IconButton>
                  <InfoIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </FormLabel>
            <br />
            <Stack direction="row" spacing={2} alignItems="center">
              <Switch
                color="error"
                value={isClearAppData}
                onChange={handleClearAppDataChange}
                disabled={!isConfirmBtnDisabled}
              />
              
                <>
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                  >
                    <TextField
                      autoFocus
                      color="secondary"
                      variant="outlined"
                      name="confirmedPassword"
                      label="Confirm Password"
                      type="password"
                      error={isConfirmedError}
                      helperText={confirmedErrorMessages}
                      onChange={handleConfirmPwChange}
                      size="small"
                      sx={{
                        height: "40px",
                        minWidth: "150px",
                      }}
                    />
                  </Box>
                  <LoadingButton
                    loading={isSubmit}
                    loadingPosition="start"
                    disabled={isConfirmBtnDisabled}
                    startIcon={isConfirmBtnDisabled ? <Done /> : <Password />}
                    variant="contained"
                    color="success"
                    onClick={handleConfirmPw}
                    size="small"
                    sx={{
                      height: "40px",
                      minWidth: "150px",
                    }}
                  >
                    {isConfirmBtnDisabled ? "Confirmed" : "Confirmation"}
                  </LoadingButton>
                </>
            </Stack>
          </FormControl>
          <br />
          <br />
          <h4>Deployment Strategy</h4>
          <br />
          <div style={{ paddingLeft: "25px" }}>
            <Stack spacing={2} direction="row">
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Software Update For Terminal{" "}
                  <IconButton onClick={() => setinfoAlert1Open(true)}>
                    <InfoIcon fontSize="small" />
                  </IconButton>
                  <br />
                  <Collapse in={infoAlert1Open}>
                    <Alert
                      severity="info"
                      onClose={() => setinfoAlert1Open(false)}
                    >
                      <AlertTitle>
                        <strong>Regular Update (Default)</strong>
                      </AlertTitle>
                      User Acceptance is needed before the update
                      <br />
                      <br />
                      <AlertTitle>
                        <strong>Silent Update</strong>
                      </AlertTitle>
                      Terminal should update automatically
                      <br />
                      <br />
                      <AlertTitle>
                        <strong>Schedule Update</strong>
                      </AlertTitle>
                      Update the software using config schedule time
                    </Alert>
                  </Collapse>
                </FormLabel>

                <RadioGroup
                  sx={{ paddingLeft: "20px" }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="deployStgy"
                  value={deployStgy ? deployStgy : "REGULAR_UPDATE"}
                  onChange={handleDplyStgyChange}
                >
                  <FormControlLabel
                    value="REGULAR_UPDATE"
                    control={<Radio />}
                    label="Regular Updates"
                  />
                  <FormControlLabel
                    value="SILENT_UPDATE"
                    control={<Radio />}
                    label="Silent Update"
                  />
                  <FormControlLabel
                    value="SCHEDULE_UPDATE"
                    control={<Radio />}
                    label="Schedule Update"
                  />
                </RadioGroup>
              </FormControl>
            </Stack>
            {deployStgy === "SCHEDULE_UPDATE" && (
              <DateTimeSelector
                name="schedUpdateTime"
                value={scheduleDate}
                label="Schedule Date/Time"
                onChange={(newValue) => handleScheDateChange(newValue)}
                setScheduleDate={setScheduleDate}
              />
            )}
            <Stack spacing={2} sx={{ my: 4 }}>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Settlement Setting
                  <IconButton onClick={() => setinfoAlert2Open(true)}>
                    <InfoIcon fontSize="small" />
                  </IconButton>
                  <br />
                  <Collapse in={infoAlert2Open}>
                    <Alert
                      severity="info"
                      onClose={() => setinfoAlert2Open(false)}
                    >
                      <AlertTitle>
                        <strong>Immediate Software Update</strong>
                      </AlertTitle>
                      Skip the Settlement when Software Update and Execute
                      Software Update Immediately
                      <br />
                      <br />
                      <AlertTitle>
                        <strong>
                          Auto Settlement before the Software Update
                        </strong>
                      </AlertTitle>
                      Execute Settlement Immediately before the Software Update
                      <br />
                      <br />
                      <AlertTitle>
                        <strong>
                          Software Update after the Next Settlement
                        </strong>
                      </AlertTitle>
                      Execute software update after the terminal next Settlement
                    </Alert>
                  </Collapse>
                </FormLabel>
                <RadioGroup
                  sx={{ paddingLeft: "20px" }}
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="stlmntSetting"
                  value={setlmntSetting ? setlmntSetting : "SKIP_SETTLEMENT"}
                  onChange={handleSetlmntSetting}
                >
                  <FormControlLabel
                    value="SKIP_SETTLEMENT"
                    control={<Radio />}
                    label="Skip Settlement"
                  />
                  <FormControlLabel
                    value="AUTO_SETTLEMENT"
                    control={<Radio />}
                    label="Auto Settlement"
                  />
                  <FormControlLabel
                    value="NEXT_SETTLEMENT"
                    control={<Radio />}
                    label="Update After Next Settlement"
                  />
                </RadioGroup>
              </FormControl>
            </Stack>
          </div>
          <TextField
            fullWidth
            id="outlined-multiline-static"
            value={data?.description}
            name="description"
            label="Description"
            multiline
            variant="outlined"
            color="secondary"
            rows={4}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions sx={{ p: "1.25rem" }}>
          <Button onClick={handleOnClose} variant="outlined" color="error">
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            color="success"
            loading={isBtnLoading}
            variant="contained"
            loadingPosition="start"
            startIcon={<SaveIcon />}
          >
            Create
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  )
}

export default CreateNewGroupsModal
